import { useNavigate } from '@tanstack/react-router'
import { useCallback } from 'react'

export const useAmoeLaunch = () => {
  const navigate = useNavigate()

  const close = useCallback(
    () =>
      navigate({
        to: '.',
        search: { amoe: undefined },
        resetScroll: false,
      }),
    [navigate],
  )

  const open = useCallback(
    () =>
      navigate({
        to: '.',
        search: {
          amoe: 'postal-request-code',
        },
        resetScroll: false,
      }),

    [navigate],
  )

  return {
    open,
    close,
  }
}
